module.exports = __webpack_public_path__ + "static/img/tool-icon-live.4abd43be.png";